export * from './shared.module';
export * from './services';



// WEBPACK FOOTER //
// ./src/shared/index.ts